import type { Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

export const autosuggestionDropdownSuggestionsSx: SystemStyleObject<Theme> = {
  '& .react-autosuggest__suggestions-container': {
    position: 'absolute',
    right: 0,
    left: 0,
    zIndex: 10,
  },
  '& .react-autosuggest__suggestions-container--open': {
    maxHeight: '200px',
    overflowY: 'auto',
    padding: '4px 0',
    backgroundColor: 'background.primary',
    borderBottomLeftRadius: '4px',
    borderBottomRightRadius: '4px',
    boxShadow: 3,
  },
  '& .react-autosuggest__suggestions-list': {
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  '& .react-autosuggest__suggestion': {
    padding: '5px 12px',
    fontSize: '1em',
    cursor: 'pointer',
    '&:hover': { backgroundColor: 'common.menuItemActive' },
  },
};

export const autosuggestionDropdownSx: SystemStyleObject<Theme> = {
  '& .react-autosuggest__container': {
    position: 'relative',
    '&.react-autosuggest__container--open': {
      '& .react-autosuggest__no-result, & .react-autosuggest__warning-message': { display: 'block' },
    },
    '& input.MuiInputBase-input': { fontSize: '14px', padding: '10px 14px' },
  },
  ...autosuggestionDropdownSuggestionsSx,
  '& .react-autosuggest__no-result, & .react-autosuggest__warning-message': {
    position: 'absolute',
    right: 0,
    left: 0,
    zIndex: 10,
    maxHeight: '200px',
    padding: '10px 12px',
    overflowY: 'auto',
    color: 'text.secondary',
    textAlign: 'center',
    backgroundColor: 'background.primary',
  },
  '& .react-autosuggest__no-result': {
    borderBottomLeftRadius: '4px',
    borderBottomRightRadius: '4px',
    boxShadow: 3,
  },
  '& .react-autosuggest__warning-message': {
    position: 'static',
    display: 'none',
    borderBottom: '1px solid',
    borderBottomColor: 'border.default',
    fontSize: '13px',
  },
};
